import template from './sendMail.html';
import SendMailCtrl from './sendMailCtrl';

export default {
  template,
  bindings: {
    familyId: '<',
    isWorkbench: '<',
    loanId: '<',
    quoteId: '<',
    emailToEdit: '<',
    onBack: '&',
    modalInstance: '<',
  },
  controller: SendMailCtrl,
  controllerAs: 'vm',
};
